<template>
	<div class="name-form">
		<header-simple :title="$t('base.profile.change_name')" :subtitle="'Information about the user account.'"></header-simple>
		<form @submit.prevent="validateAndSubmit">
			<form-panel :error="form.error" :loading="model.loading">
				<input-text v-model="model.data.fullname" name="user_fullname" :placeholder="$t('labels.profile.new_name')" rules="required"/>
				<template v-slot:footer>
					<button-submit :loading="form.loading">{{ $t('buttons.actions.update_name') }}</button-submit>
				</template>
			</form-panel>
		</form>
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import FormObject from '@/classes/api/FormObject'
import HeaderSimple from '@/modules/ui/HeaderSimple'
import FormPanel from '@/modules/ui/FormPanel'
export default {
	props: [
		'user_uid'
	],
	components: {
		HeaderSimple,
		FormPanel
	},
	data () {
		return {
			model: new ApiObject(),
			form: new FormObject()
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.editUser()
				})
		},
		getUser () {
			this.model.loading = true
			this.$api.users.getByUid(this, this.user_uid)
				.then(response => {
					this.$log.info('account information', 'users.getByUid OK', response)()
					this.model.data = response.body
				})
				.catch(error => {
					this.$log.error('account information', 'users.getByUid ERROR', error)()
					this.model.error = error
				})
				.finally(() => {
					this.model.loading = false
				})
		},
		editUser () {
			this.form.loading = true
			this.form.error = null
			this.$api.users.edit(this, this.user_uid, this.model.data)
				.then(response => {
					this.$log.info('user profile', 'users.edit OK', response)()
					this.$root.$emit('add-floating-box', { type: 'success', title: 'Success', message: 'Name updated.' })
				})
				.catch(error => {
					// this.$log.error('user profile', 'users.edit ERROR', error)()
					this.form.error = error
					this.$root.$emit('add-floating-box', { type: 'error', title: 'Error', message: 'Issue try to update name. Try again please.' })
				})
				.finally(() => {
					this.form.loading = false
					this.$store.dispatch('getUser', { context: this })
				})
		}
	},
	mounted () {
		this.getUser()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/accountinformation/NameForm.vue